export default function hideTooltip () {
  return {
    type: 'HIDE_TOOLTIP',
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-tooltips/actions/hideTooltip.js